import React from 'react';
import RoundedProgressBar from "./RoundProgressBar";
import LineProgressBar from "./LineProgressBar";
import "./Skills.scss";
import Boy from "../../assets/images/boy.png";



export default function Skills() {
    return(
        <div className="w-100 d-flex justify-content-start flex-column m-0 p-2">
            <div className="row d-flex flex-row m-0 p-0">
                <div className="col-md-4 col-sm-12 mb-5  text-center d-flex justify-content-center">
                    <p className="sub-header-main align-self-center">Web Developing</p>
                </div>
                <div className="col-md-8 col-sm-12 round-skill-container">
                    <div className="w-100 col-md-4 col-sm-12 d-flex flex-column ">
                        <RoundedProgressBar color="blue" value="92%"/>
                        <p className="dash-sub">React</p>
                    </div>
                    <div className="col-md-4 col-sm-12 d-flex flex-column ">
                        <RoundedProgressBar color="blue" value="92%"/>
                        <p className="dash-sub">Node + Express</p>
                    </div>
                    <div className="d-flex flex-column col-md-4 col-sm-12">
                        <RoundedProgressBar color="yellow" value="75%"/>
                        <p className="dash-sub">Angular</p>
                    </div>


                </div>
            </div>

            <div className="row mt-5 m-0 p-0"></div>

            <div className="row m-0 p-0">
                <div className="col-md-4 col-sm-12 mb-5 text-center d-flex justify-content-center">
                    <p className="sub-header-main align-self-center">Mobile App Developing</p>
                </div>
                <div className="col-md-8 col-sm-12 round-skill-container">
                    <div className="d-flex flex-column col-md-4">
                        <RoundedProgressBar color="blue" value="97%"/>
                        <p className="dash-sub">Flutter</p>
                    </div>
                    <div className="d-flex flex-column col-md-4">
                        <RoundedProgressBar color="yellow" value="80%"/>
                        <p className="dash-sub">Java</p>
                    </div>
                    <div className="d-flex flex-column col-md-4">
                        <RoundedProgressBar color="yellow" value="80%"/>
                        <p className="dash-sub">React Native</p>
                    </div>



                </div>
            </div>

            <div className="row mt-5 m-0 p-0"></div>

            <div className="row bg-transparent text-light m-0 p-0">
                <div className="col d-flex flex-column">
                    <p className="sub-header-main p-3 align-self-center">Graphics Designing (Adobe)</p>
                    <div className="text-center mt-5 p-3">
                        <LineProgressBar value="80%"/>
                    </div>
                    <p className="font-weight-bold mt-1">80%</p>
                </div>
                <div className="col d-flex flex-column justify-content-around">
                    <p className="sub-header-main p-3 align-self-center">Game Developing (Unity)</p>
                    <div className="text-center mt-5">
                        <LineProgressBar value="77%"/>
                    </div>
                    <p className="font-weight-bold mt-1">77%</p>
                </div>
                <div className="col d-flex flex-column justify-content-around">
                    <p className="sub-header-main p-3 align-self-center">Database Management</p>
                    <div className="text-center mt-5">
                        <LineProgressBar value="79%"/>
                    </div>
                    <p className="font-weight-bold mt-1">79 %</p>
                </div>
            </div>

            <div className="row mt-5 m-0 p-0"></div>

            <div className="d-flex flex-column m-0 p-0">

                    <p className="sub-header-main1">Soft Skills</p>
                    <ul className="text-white soft-skill">
                        <li className="mt-3">Team Work</li>
                        <li className="mt-3">Leadership</li>
                        <li className="mt-3">Motivated</li>
                        <li className="mt-3">Adaptability</li>
                        <li className="mt-3">Hard Working</li>
                        <li className="mt-3">Self Discipline</li>
                    </ul>

            </div>

        </div>
    );
}